import styled from 'styled-components';
import { Button } from '@sede-enterprise/shell-ds-react-framework';

// eslint-disable-next-line import/prefer-default-export
export const ShellButton = styled(Button)`
  :disabled {
    pointer-events: unset;
    span {
      color: rgb(162 162 162);
    }
  }
  svg {
    margin-right: 5px;
    circle: {
      stroke: rgb(0, 151, 187);
    }
  }
`;
